import React, {
	ChangeEventHandler,
	CSSProperties,
	FocusEventHandler,
	KeyboardEventHandler,
	useState,
} from "react";
import { FloatingLabel, Form } from "react-bootstrap";

const BftInput = ({
	as,
	className,
	containerStyle,
	errors,
	disabled,
	icon,
	inputStyle,
	name,
	onChange,
	onBlur,
	placeholder,
	readOnly,
	required,
	type,
	value,
	wrapperStyle,
	inputClass,
	isInvalid,
	isValid,
	autoFocus,
	onKeyDown,
	validateMaxLength,
	onPaste,
}: {
	as?: any;
	className?: string;
	containerStyle?: CSSProperties;
	errors?: any;
	disabled?: boolean;
	icon?: string;
	inputStyle?: CSSProperties;
	name?: string;
	onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	onBlur?: FocusEventHandler;
	placeholder?: string;
	readOnly?: boolean;
	required?: boolean;
	type?: string;
	value?: any;
	wrapperStyle?: CSSProperties;
	inputClass?: string;
	isInvalid?: boolean;
	isValid?: boolean;
	autoFocus?: boolean;
	onKeyDown?: KeyboardEventHandler | undefined;
	validateMaxLength?: boolean;
	onPaste?: boolean;
}): any => {
	const inputRef = React.useRef<any>(null);
	const [error, setError] = useState<string | null>(null);

	const containerIconClass = icon ? "input-group" : "";
	const floatingLabelIconClass = icon ? "form-floating-group flex-grow-1" : "";

	const handleClick = () => {
		if (inputRef && inputRef.current) inputRef.current.focus();
	};

	const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
		const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];

		if (validateMaxLength && !allowedKeys.includes(e.key) && (e.key < "0" || e.key > "9")) {
			e.preventDefault();
		}
	};

	const handleBlur: FocusEventHandler<HTMLInputElement> = (e) => {
		if (validateMaxLength && e.target.value.length !== 10) {
			setError("Il numero deve essere esattamente di 10 cifre.");
		} else {
			setError(null);
		}

		if (onBlur) {
			onBlur(e);
		}
	};

	const handlePaste: React.ClipboardEventHandler<HTMLInputElement> = (e) => {
		const pastedText = e.clipboardData.getData("Text");
		if (pastedText.includes("+")) {
			e.preventDefault();
			const filteredText = pastedText.replace(/\+/g, "");
			document.execCommand("insertText", false, filteredText);
		}
	};

	return (
		<div className={className} style={wrapperStyle}>
			<div
				onClick={handleClick}
				className={`container ${containerIconClass}`}
				style={containerStyle}
			>
				{icon && (
					<span className="input-group-text icon-bft-input">
						<i className={`fas ${icon}`}></i>
					</span>
				)}
				<FloatingLabel
					controlId={name}
					label={placeholder}
					className={`mb-3 ${floatingLabelIconClass}`}
				>
					<Form.Control
						ref={inputRef}
						as={as}
						aria-label={name}
						data-testid={name}
						tabIndex={0}
						type={type}
						name={name}
						onChange={onChange}
						onBlur={handleBlur}
						placeholder={placeholder}
						value={value}
						style={{ ...inputStyle }}
						maxLength={validateMaxLength ? 10 : 255}
						disabled={disabled}
						readOnly={readOnly}
						className={`${inputClass} ${error ? "is-invalid" : ""}`}
						isInvalid={isInvalid || !!error}
						isValid={isValid && !error}
						autoFocus={autoFocus}
						onKeyDown={validateMaxLength ? handleKeyDown : onKeyDown}
						autoComplete="new-password"
						onPaste={handlePaste}
					/>
				</FloatingLabel>
				{error && <div className="invalid-feedback">{error}</div>}
			</div>
		</div>
	);
};

export default BftInput;
